// Per-theme capability map. Dugout's features are gated here so knvb/frf/fmf/default never see
// them; a feature can later be enabled for another theme by adding it to that theme's entry.
// Callers pass the RESOLVED theme (config/theme.ts). The `process.env.NEXT_PUBLIC_THEME` default is
// only a fallback for code with no request context — app code always passes the value explicitly.

export interface ThemeFeatures {
  /** Players/items expose an `alternateIcon` (shape) selected by the global `iconType`. */
  shapeIcons: boolean;
  /** The Futsal goal is offered. */
  futsalGoal: boolean;
  /** A new drawing can be initialised from a formation via URL params. */
  formations: boolean;
  /** Lined-pitch PNG fields on the voetbalvorm / `pitchType` taxonomy. */
  linedFields: boolean;
  /** action-based postMessage dialect (initialized/datacallback/destroy) + `img_data` image. */
  actionContract: boolean;
}

const NONE: ThemeFeatures = {
  shapeIcons: false,
  futsalGoal: false,
  formations: false,
  linedFields: false,
  actionContract: false,
};

const BY_THEME: Record<string, ThemeFeatures> = {
  dugout: {
    shapeIcons: true,
    futsalGoal: true,
    formations: true,
    linedFields: true,
    actionContract: true,
  },
};

export const themeFeatures = (
  theme: string | undefined = process.env.NEXT_PUBLIC_THEME,
): ThemeFeatures => BY_THEME[theme ?? ''] ?? NONE;

export const isDugout = (
  theme: string | undefined = process.env.NEXT_PUBLIC_THEME,
): boolean => theme === 'dugout';
